import Joi from 'joi';

import { optionalString, requiredString } from '../../../utils/validators';

export const validationSchema = Joi.object({
  firstName: requiredString,
  middleName: optionalString,
  lastName: requiredString,
});
